<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#f560cd"
    :border="true"
    inactive-color="#979799"
    z-index="999"
  >
    <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/home2.png' : '/img/footer/home.png'"
          :alt="$t('foorter.index')"
        />
      </template>
    </van-tabbar-item>

    <!-- 視訊廳 -->
    <van-tabbar-item to="/Video">
      <span>{{ $t("foorter.subscribe") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/ys1.png' : '/img/footer/ys.png'"
          :alt="$t('foorter.subscribe')"
        />
      </template>
    </van-tabbar-item>

    <!-- 啟動 -->
    <van-tabbar-item to="/Game">
      <span>{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/fl1.png' : '/img/footer/fl.png'"
          :alt="$t('foorter.video')"
        />
      </template>
    </van-tabbar-item>

    <!-- 個人 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/gr1.png' : '/img/footer/gr.png'"
          :alt="$t('foorter.my')"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {
    updateActive(route) {
      if (route.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (route.name == "video") {
        this.active = 1;
        this.show = true;
      } else if (route.name == "game") {
        this.active = 2;
        this.show = true;
      } else if (route.name == "mine") {
        this.active = 3;
        this.show = true;
      } else {
        this.show = false;
      }
    }
  },
  watch: {
    $route(to) {
      this.updateActive(to);
    }
  },
  created() {
    this.updateActive(this.$route);
  }
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
.van-tabbar {
  height: @tabbar-height;
}
.van-tabbar-item__icon img {
  height: 48px;
  width: 48px;
  object-fit: contain;
}
.van-tabbar-item {
  font-size: 24px;
  line-height: 40px;
}
[class*="van-hairline"]::after {
  border: none !important;
}
</style>
